import 'react';
import { BASE_SHEET_WIDTH } from '@i-ark/constants';
import { InputTypes } from '@i-ark/models';
import '@utils/component-framework';
import '@tanstack/react-query';
import { selectLastComponentEditorVersion } from '../../../state/selectors/data.last-editor-version.js';
import { selectOriginalComponentVersion } from '../../../state/selectors/data.original-version.js';
import { iArkStore } from '../../../state/store.js';
import { useUserOwnsEntry } from '../../hook.user-owns-entry.js';
import { RichTextInput } from './RichTextInput.js';
import { RichTextInputReadonly } from './RichTextInputReadonly.js';
import { SimpleInput } from './SimpleInput.js';
import { SimpleInputReadonly } from './SimpleInputReadonly.js';
import { jsx } from 'react/jsx-runtime';

const Input = props => {
  const entryKey = iArkStore.useSelector(state => state.entryKey);
  const userOwnsEntry = useUserOwnsEntry(entryKey);
  const latestComponentEditorVersion = iArkStore.useSelector(selectLastComponentEditorVersion);
  const originalComponentVersion = iArkStore.useSelector(selectOriginalComponentVersion);

  // simple / oneline inputs are only used for sheets created using the legacy
  // builder with the explicit type of "INPUT" or that are too small to
  // logically contain more than a single line of text
  const showSimpleInput = latestComponentEditorVersion === 1 && props.item.type === InputTypes.INPUT;
  if (!userOwnsEntry) {
    return showSimpleInput ? /*#__PURE__*/jsx(SimpleInputReadonly, {
      ...props
    }) : /*#__PURE__*/jsx(RichTextInputReadonly, {
      ...props
    });
  }
  return showSimpleInput ? /*#__PURE__*/jsx(SimpleInput, {
    ...props
  }) : /*#__PURE__*/jsx(RichTextInput, {
    ...props,
    item: {
      ...props.item,
      type:
      // for components created from the legacy editor, where editors have
      // inserted tiny multi-line inputs, force type to be input, which
      // will properly apply vertical centering of the text entered by the
      // user
      originalComponentVersion === 1 && props.item.size.height * props.pageAspectRatio * BASE_SHEET_WIDTH < 40 ? InputTypes.INPUT : props.item.type
    }
  });
};

export { Input };
//# sourceMappingURL=Input.js.map
